import { useQuery, useMutation } from '@apollo/client';
import keycloak from '../keycloak';
import { GET_MY_PROFILE, UPDATE_MY_PROFILE, DELETE_USER, CHANGE_APPROVER_TIER } from '../services/graphql';
import { useDispatch } from "react-redux";
import {
  userLoginSuccess,
  userLoginError,
  setAccessLevel,
} from "../store/actions/graphqlActions";

const useProfileQuery = (email) => {
    const dispatch = useDispatch();
    const resolveCurrentEmail = () => keycloak?.tokenParsed?.email || sessionStorage.getItem("email") || email || null;

    const syncAuthState = (status) => {
        if (status.authorized) {
            localStorage.setItem("authorized", status.authorized);
            localStorage.setItem("access_level", status.accessLevel);
            dispatch(userLoginSuccess({ email: resolveCurrentEmail() }));
            if (status.accessLevel) {
                dispatch(setAccessLevel(status.accessLevel));
            }
        } else {
            dispatch(userLoginError());
        }
    };

    const { loading, error, data, refetch } = useQuery(GET_MY_PROFILE, {
        variables: { email },
        context: {
            headers: {
                Authorization: keycloak && keycloak.token ? `Bearer ${keycloak.token}` : '',
            },
        },
    });

    
    const [updateProfile] = useMutation(UPDATE_MY_PROFILE, {
        context: {
            headers: {
                Authorization: keycloak && keycloak.token ? `Bearer ${keycloak.token}` : '',
            },
        },
        onCompleted: (data) => {
            const status = data.modifyUserProfile.status;
            syncAuthState(status);
        }
    });

    const updateMyProfile = async (userEmail, changes) => {   
        try {
            const { data } = await updateProfile({
                variables: { userEmail, modification: changes },
                refetchQueries: [
                    {
                        query: GET_MY_PROFILE,
                        variables: { email: userEmail },
                    },
                ],
                awaitRefetchQueries: true,
            });
            const updatedProfileData = data.modifyUserProfile.body;
        
            return updatedProfileData;

        } catch (error) {
            console.error(error);
            alert("Failed to update page. Please try again.");
        }
    }

    const [deleteSelectedUser] = useMutation(DELETE_USER, {
        context: {
            headers: {
                Authorization: keycloak && keycloak.token ? `Bearer ${keycloak.token}` : '',
            },
        },
        onCompleted: (data) => {
            const status = data.deleteUser.status;
            syncAuthState(status);
        }
    });

    const deleteUser = async (email) => {   
        try {
          await deleteSelectedUser({ variables: { userEmail: email} });
        } catch (error) {
            console.error(error);
            alert("Failed to delete user. Please try again.");
        }
    }

    const [updateTier] = useMutation(CHANGE_APPROVER_TIER, {
        context: {
            headers: {
                Authorization: keycloak && keycloak.token ? `Bearer ${keycloak.token}` : '',
            },
        },
        onCompleted: (data) => {
            const status = data.changeApproverTier.status;
            syncAuthState(status);
        }
    });

    const changeApprovalTier = async (email, tier) => {   
        try {
          await updateTier({ variables: { userEmail: email, newTier: tier} });
        } catch (error) {
            console.error(error);
            alert("Failed to update approver tier. Please try again.");
        }
    }

    return {loading, data, refetch, updateMyProfile, deleteUser, changeApprovalTier};

};

export default useProfileQuery;
